import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Input, LOCALE_ID, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { IGrid } from 'bi-interfaces/lib/interfaces/IGrid';
import { BIChildGridComponent } from '../BI-ChildGrid/bi-childGrid.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoggerService } from '../../services/logger.service';
import { BIModulesService } from '../../bi-modules.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { GetValuePipe } from '../../pipes/get-value.pipe';
import { DataTypes, IDataSource } from 'bi-interfaces';
import { IColumns } from 'bi-interfaces/lib/interfaces/IColumns.interface';
import { INavBtn } from 'bi-interfaces/lib/interfaces/inav-btn';
import { TranslateService } from '@ngx-translate/core';
import { ErrorDetailsService } from '../../services/error-details.service';
import { IntlService } from '@progress/kendo-angular-intl';
import { RowArgs } from '@progress/kendo-angular-grid';
import { Router } from '@angular/router';
import { UiProfileService } from '../../services/ui-profile.service';
import { CreateDialog } from '../bi-dialog/createDialog.service';

@Component({
  selector: 'lib-bi-master-grid-details',
  templateUrl: './bi-master-grid-details.component.html',
  styleUrls: ['./bi-master-grid-details.component.scss']
})
export class BiMasterGridDetailsComponent extends BIChildGridComponent implements IGrid, AfterViewInit {
  @Input() map = new Map();
  DomIDDetails: any;
  dataItems: any = [];
  @Input() DataServiceLines!: any[];
  @Input() ColumnsLines!: IColumns[];
  @Input() changeSetLines!: any;
  @Input() navButtonsLinesGroup!: INavBtn;
  @Input() DisabledLinesGridChild: boolean = false;
  @Input() Key!: string;
  @Input() DataTypeKey1!: string;
  @Input() DataTypeKey2!: string;
  @Input() colorsLines: any;
  @Input() ManualParams: boolean = false;
  @Output() AfterAddRowLinesGroup = new EventEmitter<any>();
  @Output() OnLoadDataDetailsGroup = new EventEmitter<any>();
  @Output() OnRowChangeDataDetails = new EventEmitter<any>();
  @ViewChildren('masterGridDetailsChildren') BGridDetailsChildren!: QueryList<IGrid>;
  formLines: any = {};
  BGridDetailsChildrenGroup: any[] = [];
  public expandedDetailKeys: number[] = [1];
  constructor(
    formBuilder: FormBuilder,
    loggerService: LoggerService,
    biService: BIModulesService,
    messages: MessageService,
    getValuePipe: GetValuePipe,
    cd: ChangeDetectorRef,
    translateService: TranslateService,
    errorDetailsService: ErrorDetailsService,
    @Inject(LOCALE_ID) localeId: any,
    intlService: IntlService,
    router: Router,
    uiProfileService: UiProfileService,
    @Inject('CreateDialog') public _createDialg: CreateDialog,
  ) {
    super(formBuilder, loggerService, biService, messages, getValuePipe, cd, translateService, errorDetailsService, localeId, intlService, router, uiProfileService,_createDialg);
  }

  Getvalue(DataITem: any) {
    if (!this.map.has(DataITem[this.Key ? this.Key : this.DataService.Key])) {
      this.DomIDDetails = this.Key ? this.Key : this.DataService.Key;
      this.formLines[this.RowIdentifier] = [''];
      this.formLines[this.ChangeSet_Status] = [''];
      let formControl: any = {}
      if (this.map.get(DataITem[this.Key ? this.Key : this.DataService.Key])) this.map.get(DataITem[this.Key ? this.Key : this.DataService.Key]).DataSource = [];
      this.map.set(DataITem[this.Key ? this.Key : this.DataService.Key], { DataSource: this.DataServiceLines[DataITem[this.Key ? this.Key : this.DataService.Key]] });
      if (this.DataServiceLines[DataITem[this.Key ? this.Key : this.DataService.Key]]?.Columns?.length) {
        this.DataServiceLines[DataITem[this.Key ? this.Key : this.DataService.Key]].Columns.forEach((res: any) => formControl[res.Name] = [null]);
      }
      formControl[this.RowIdentifier] = [''];
      formControl[this.ChangeSet_Status] = [''];
      this.ColumnsLines.forEach(res => {
        if (formControl.hasOwnProperty(res.Name)) formControl[res.Name] = [{ value: res.DefaultValue, disabled: !res.IsEditable }, res.Validators];
      })
      this.map.set(DataITem[this.Key ? this.Key : this.DataService.Key], { DataSource: this.DataServiceLines[DataITem[this.Key ? this.Key : this.DataService.Key]] });

      if (!this.ManualParams) {
        if (this.DataService.Key4) {
          this.DataServiceLines[DataITem[this.Key ? this.Key : this.DataService.Key]].Params = [
            { Name: [this.DataService.Key], Operator: 'eq', value: DataITem[this.DataService.Key], DataType: this.DataTypeKey1 ? this.DataTypeKey1 : DataTypes.NUMERIC },
            { Name: [this.DataService.Key2], Operator: 'eq', value: DataITem[this.DataService.Key2], DataType: this.DataTypeKey2 ? this.DataTypeKey2 : DataTypes.Text },
            { Name: [this.DataService.Key3], Operator: 'eq', value: DataITem[this.DataService.Key3], DataType: DataTypes.Text },
            { Name: [this.DataService.Key4], Operator: 'eq', value: DataITem[this.DataService.Key4], DataType: DataTypes.Text },
          ]
        }
        else if (this.DataService.Key3) {
          this.DataServiceLines[DataITem[this.Key ? this.Key : this.DataService.Key]].Params = [
            { Name: [this.DataService.Key], Operator: 'eq', value: DataITem[this.DataService.Key], DataType: this.DataTypeKey1 ? this.DataTypeKey1 : DataTypes.NUMERIC },
            { Name: [this.DataService.Key2], Operator: 'eq', value: DataITem[this.DataService.Key2], DataType: this.DataTypeKey2 ? this.DataTypeKey2 : DataTypes.Text },
            { Name: [this.DataService.Key3], Operator: 'eq', value: DataITem[this.DataService.Key3], DataType: DataTypes.Text },
          ]
        }
        else if (this.DataService.Key2) {
          this.DataServiceLines[DataITem[this.Key ? this.Key : this.DataService.Key]].Params = [
            { Name: [this.DataService.Key], Operator: 'eq', value: DataITem[this.DataService.Key], DataType: this.DataTypeKey1 ? this.DataTypeKey1 : DataTypes.NUMERIC },
            { Name: [this.DataService.Key2], Operator: 'eq', value: DataITem[this.DataService.Key2], DataType: this.DataTypeKey2 ? this.DataTypeKey2 : DataTypes.Text },
          ]
        }
        else {
          this.DataServiceLines[DataITem[this.Key ? this.Key : this.DataService.Key]].Params = [
            { Name: [this.DataService.Key], Operator: 'eq', value: DataITem[this.DataService.Key], DataType: this.DataTypeKey1 ? this.DataTypeKey1 : DataTypes.NUMERIC },
          ]
        }
      }
    }

    return this.map.get(DataITem[this.Key ? this.Key : this.DataService.Key]);
  }

  ngAfterViewInit(): void {
  }

  override insertDataItemInRow(args: any) {
    this.dataItem = args.dataItem;
    if (!this.BGridDetailsChildrenGroup[this.dataItem[this.Key ? this.Key : this.DataService.Key]]?.formGroups?.length ||
      this.BGridDetailsChildrenGroup[this.dataItem[this.Key ? this.Key : this.DataService.Key]]?.formGroups?.every((res: any) => res.status !== "INVALID")) {
      this.CellClick.emit(args);
      this.CurrentSelectRow = this.createFormGroup(args);
      args.sender.editCell(
        args.rowIndex,
        args.columnIndex,
        this.createFormGroup(args)
      );
      this.OverviewDataBindingSubscribtion(this.RowID);
    }
  }

  async OnLoadDataDetails(dataItem: any, rowIndex: any) {
    setTimeout(() => {
      this.OnLoadDataDetailsGroup.emit({ event: this.BGridDetailsChildrenGroup, rowIndex, dataItem });
    });
  }
  async RowChangeDataDetails(dataItem: any, rowIndex: any) {
    setTimeout(() => {
      this.OnRowChangeDataDetails.emit({ event: this.BGridDetailsChildrenGroup, rowIndex, dataItem })
    });
  }

  async AfterAddRowLine(dataItem: any, rowIndex: any) {
    this.AfterAddRowLinesGroup.emit({ event: this.BGridDetailsChildrenGroup, rowIndex, dataItem })
  }

  BGridDetailsChildren_BeforeAddRow(dataItem: any) {
    setTimeout(() => {
      this.BGridDetailsChildrenGroup[dataItem[this.Key ? this.Key : this.DataService.Key]]?.AllowAdd.next(true);
    })
  }
  filterInRefrenceChildren(dataItem: any, rowIndex: number) {
    this.BGridDetailsChildrenGroup[dataItem[this.Key ? this.Key : this.DataService.Key]] =
      this.BGridDetailsChildren['_results'].find((res: any) => res["DomID"] === dataItem[this.Key ? this.Key : this.DataService.Key]);
    if (
      !this.BGridDetailsChildrenGroup[dataItem[this.Key ? this.Key : this.DataService.Key]] ||
      !this.BGridDetailsChildrenGroup[dataItem[this.Key ? this.Key : this.DataService.Key]]?.formGroups?.filter((res: any) => res.status === "INVALID").length) {
      this.EnableDisableGrid(!this.DisabledLinesGridChild, dataItem);
    }
    return this.BGridDetailsChildrenGroup[dataItem[this.Key ? this.Key : this.DataService.Key]]
  }

  EnableDisableGrid(IsEditable: boolean, dataItem: any) {
    if (this.BGridDetailsChildrenGroup[dataItem[this.Key ? this.Key : this.DataService.Key]]) {
      if (IsEditable) {
        this.BGridDetailsChildrenGroup[dataItem[this.Key ? this.Key : this.DataService.Key]].Columns.forEach((element: any) => {
          if (element.IsEditable)
            this.BGridDetailsChildrenGroup[dataItem[this.Key ? this.Key : this.DataService.Key]].CurrentSelectRow?.get(element.Name)?.enable({ emitEvent: false });
        });
      } else {
        this.BGridDetailsChildrenGroup[dataItem[this.Key ? this.Key : this.DataService.Key]].CurrentSelectRow?.disable({ emitEvent: false });
      }
    }
  }

  expandGrid() {
    this.expandedDetailKeys = []
  }


  public expandDetailsBy = (dataItem: any): number => {
    return dataItem[this.Key ? this.Key : this.DataService.Key];
  };
}
